export default __webpack_public_path__ + "static/media/16.e30366d4.png";